// src/services/api/dashboard.api.ts
import axios from "axios";
import { BASE_URL } from "./apiconfig";

export const getSpasWithErrors = async (token: string | null) => {
    try {
        const { data } = await axios.get(`${BASE_URL}/dashboard/spas-with-errors`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return data;
    } catch (error) {
        console.log("Failed to fetch spas with errors. ", error);
        throw error;
    }
};

export const getSpasWithTempDifference = async (token: string | null) => {
    try {
        const { data } = await axios.get(`${BASE_URL}/dashboard/spas-with-temp-difference`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return data;
    } catch (error) {
        console.log("Failed to fetch spas with temperature difference. ", error);
        throw error;
    }
};

export const getSpasConnectedThisWeek = async (token: string | null) => {
    try {
        const { data } = await axios.get(`${BASE_URL}/dashboard/spas-connected-this-week`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return data;
    } catch (error) {
        console.log("Failed to fetch spas connected this week. ", error);
        throw error;
    }
};

export const getSpasConnectedLastWeek = async (token: string | null) => {
    try {
        const { data } = await axios.get(`${BASE_URL}/dashboard/spas-connected-last-week`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return data;
    } catch (error) {
        console.log("Failed to fetch spas connected last week. ", error);
        throw error;
    }
};

export const getSpasWithSbHours = async (token: string | null) => {
    try {
        const { data } = await axios.get(`${BASE_URL}/dashboard/spas-with-sb-hours`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return data;
    } catch (error) {
        console.log("Failed to fetch spas with SB hours. ", error);
        throw error;
    }
};

export const getSpaLocations = async (token: string | null, guids: string[]) => {
    try {
        const { data } = await axios.post(`${BASE_URL}/dashboard/spa-locations`, { guids }, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return data;
    } catch (error) {
        console.log("Failed to fetch spa locations. ", error);
        throw error;
    }
};

export const getOnlineMovedSpas = async (token: string | null) => {
    try {
      const { data } = await axios.get(`${BASE_URL}/spas?online=true&is_moved=true`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return data;
    } catch (error) {
      console.log("Failed to fetch online moved spas. ", error);
      throw error;
    }
  }